<template>
  <div class="main">
    <el-row>
      <el-col :xs="24" :sm="24" :md="24" :lg="3" :xl="3"  class="left-menu">
        <div>
          <el-menu
            class="el-menu-vertical-demo"
            router>
            <el-menu-item class="left-menu-item"
                          :id="'leftNav'+index"
                          v-for="(item,index) in leftMenu"
                          :key="index"
                          :index="item.index"
                          @click="handelHover(index)">
              {{item.title}}
            </el-menu-item>
          </el-menu>
        </div>
      </el-col>
      <el-col :xs="24" :sm="24" :md="24" :lg="21" :xl="21">
        <div class="right-section">
          <router-view></router-view>
        </div>
      </el-col>
    </el-row>

    <!--<div class="left-menu">-->
      <!--<el-menu-->
        <!--class="el-menu-vertical-demo"-->
        <!--router>-->
        <!--<el-menu-item class="left-menu-item"-->
                      <!--:id="'leftNav'+index"-->
                      <!--v-for="(item,index) in leftMenu"-->
                      <!--:key="index"-->
                      <!--:index="item.index"-->
                      <!--@click="handelHover(index)">-->
          <!--{{item.title}}-->
        <!--</el-menu-item>-->
      <!--</el-menu>-->
    <!--</div>-->
    <!--<div class="right-section">-->
      <!--<router-view></router-view>-->
    <!--</div>-->
  </div>
</template>

<script>
  import axios from '../axios'

  export default {
    name: "userCenter",
    data() {
      return {
        leftMenu: [
          {title:this.$t("userInfo.Personal"), index: '/personFile'},
          {title:this.$t("userInfo.ChangePWD"), index: '/changePassword'},
          {title:this.$t("userInfo.MyPosts"), index: '/mySubmission'},
          {title:this.$t("userInfo.purchase"), index: '/purchaseArticle'},
        ],
      }
    },
    created:function(){
      this.getUser();
    },
    mounted: function () {
      this.$nextTick(function () {
        this.menuHover();
      })
    },

    methods: {
      //判断用户是否登录
      getUser(){
        let _this = this;
        var token = localStorage.getItem('loginToken');
        if (token === '' || token == null) {

              _this.$router.push('/');
              sessionStorage.setItem('menuIndex', "0");
        }
  },


      // 页面初始化导航高亮
      menuHover() {
        var leftIndex = sessionStorage.getItem('centerMenu');
        var nav = document.getElementById('leftNav' + leftIndex);
        if (nav != null) {
          nav.classList.add('hover');
        }

      },
      //点击菜单
      handelHover(index) {
        sessionStorage.setItem('centerMenu', index);
      }
    }
  }
</script>

<style scoped>

  .main {
    width: 1170px;
    margin:0 auto;
    display: flex;
    min-height: calc(100% - 486px);
  }
  .el-row {
    width: 100%;
  }
  .left-menu {
    border-right: #009e3b 1px solid;
    height: 100%;
    background: #fff;
  }

  .el-menu {
    border: none
  }

  .left-menu-item {
    font-size: 14px;
  }

  .left-menu-item:hover, .left-menu-item.hover {
    background: #009e3b;
    color: #fff;
  }

  .right-section {
    flex: 1;
    padding: 20px 20px;
    /*border: #e5e5e5 1px solid;*/
    margin-left: 10px;
    background: #fff;
  }

  @media screen and (max-device-width: 1024px) {
    .main {width: 100%;}
    .left-menu {
      height: auto;
    }
    .el-menu {
      display:flex;
      border-bottom: #009e3b 1px solid;
    }
    .right-section {
      overflow-x: auto;
    }





  }
</style>



// WEBPACK FOOTER //
// src/components/userCenter.vue